import { QnrItemChoiceListOrientation } from '../../../models/fhir-extensions/questionnaire-item/item-choice-orientation.fhir-ext';
import { WidgetConfig } from '../../../models/widget.config';

export class LikertRadioGroupWidgetWithImageConfig extends WidgetConfig<string> {
  widgetType = 'LikertRadioGroupWidgetWithImage';
  choiceListOrientation: QnrItemChoiceListOrientation;
  hideOptionLabels: boolean;
  leftLabel: string;
  rightLabel: string;
  constructor(
    config: Partial<
      WidgetConfig<any> & {
        choiceListOrientation: QnrItemChoiceListOrientation;
        hideOptionLabels: boolean;
        leftLabel: string;
        rightLabel: string;
        invertedImages: boolean;
      }
    >
  ) {
    super(config);
    this.multiple = false;
    this.choiceListOrientation = config.choiceListOrientation ?? null;
    this.leftLabel = config.leftLabel ?? null;
    this.rightLabel = config.rightLabel ?? null;
    this.hideOptionLabels = config.hideOptionLabels ?? null;
    this.invertedImages = config.invertedImages ?? false;
  }
}
